import {
  ImgLogo,
  Container,
  FooterText,
  InstIcon,
  FaceBIcon,
  TelegramIcon,
  PhoneIcon,
  WrapIcons,
  StyledLink,
  PhonIcon,
  ContactWrap,
  MailIcon,
  FooterLink,
  FooterSocText,
  InfoWrap,
} from './Footer.styled';
import logo from '../../Images/logofooter.svg';
import { Link } from 'react-scroll';
const Footer = () => {
  return (
    <Container>
      <ImgLogo src={logo} />
      <InfoWrap>
        <FooterText>Інформація</FooterText>
        <Link to="about" smooth={true} duration={500} offset={-70}>
          <FooterLink>Про нас</FooterLink>
        </Link>
        <Link to="gallery" smooth={true} duration={500} offset={-70}>
          <FooterLink>Галерея</FooterLink>
        </Link>
      </InfoWrap>
      <ContactWrap>
        <FooterText>Контакти</FooterText>
        <StyledLink href="tel:+38097 033 29 29">
          <PhonIcon />
          +380 97 033-29-29
        </StyledLink>
        <StyledLink href="tel:+38093 033 29 29">
          <PhonIcon />
          +380 93 033-29-29
        </StyledLink>
        <StyledLink href="mailto:manager@alltenta.info">
          <MailIcon />
          manager@alltenta.info
        </StyledLink>
      </ContactWrap>
      <div>
        <FooterSocText>Соціальні мережі</FooterSocText>
        <WrapIcons>
          {' '}
          <StyledLink href="https://www.instagram.com/alltenta_ua/">
            <InstIcon />
          </StyledLink>
          <StyledLink href="https://www.facebook.com/profile.php?id=61563428046087">
            <FaceBIcon />
          </StyledLink>
          <StyledLink href="https://t.me/AlltentaBot">
            <TelegramIcon />
          </StyledLink>
          <StyledLink href="viber://add?number=380930332929">
            <PhoneIcon />
          </StyledLink>
        </WrapIcons>
      </div>
    </Container>
  );
};
export default Footer;